module.exports = {"id":"197890","name":"Arribas","rating":"74","photo":"./data/images/photos/4/197890.png","club":{"name":"U.N.A.M.","logo":"./data/images/clubs/U.N.A.M..png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Arribas0.json
// module id = 472
// module chunks = 0